const INITIAL_STATE = { 
    registro: {}, 
    modoTela: 'lista', 
    lista: [], 
    listaCategoria: [],
    listaProduto: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'PRODUTO_CATEGORIA_MODELO_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

        case 'PRODUTO_CATEGORIA_MODELO_LISTADO':
            return { ...state, lista: action.payload.data };
        
        case 'PRODUTO_CATEGORIA_MODELO_PRODUTO_SELECT_LISTADO':
            return { ...state, listaProduto: action.payload.data };

        default:
            return state;
    }
}
